import './error404.less'
import m from 'mithril'
import {t} from 'store'
import Layout from 'views/layout'
import Container from 'views/layout/container'
import Button from 'views/layout/button'
import {action} from '@codeurs/front'

export default class Error404 extends Layout {
	view() {
		const {links} = this.attrs.data
		return m('.error404', [
			m(Container, [
				m('h1.error404-title', t('error404.title')),
				m('p.error404-text', t('error404.text')),
				m('a',
					action(links.home.url),
					m(Button,
						{class: 'error404-btn mod-rounded mod-more'},
						t('error404.btn')
					)
				)
			])
		])
	}
}
